import React from 'react';

const PhotoBox1 = ({photoUrl, imgwidth}) => {
    return (
        <div style={{width: '100%', height: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            {/* <div> */}
                <img style={{width: imgwidth?imgwidth:'200px', margin: '0 auto', }} src={photoUrl} alt="photo" />
            {/* </div> */}
        </div>
    );
};

export default PhotoBox1;